import { useFolderHeaderSectionQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
}

export function useQuery(id: string) {
  const tuple = useFolderHeaderSectionQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.folder?.id ?? '',
        name: tuple.data?.folder?.name ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
